<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted (){
    // var o = document.getElementById("app");
    // var h = o.offsetHeight; 
    // var w = o.offsetWidth; 
    //   // if(w*0.04 > 16){
    //   // document.getElementById("app").style.fontSize=16 + "px";   
    //   // }
    //   // if(w*0.04 <= 16){
    //   document.getElementById("app").style.fontSize=w*0.04 + "px";   
    //   window.onresize = function(){
    //       document.getElementById("app").style.fontSize=w*0.04 + "px";   
    //   }
    }
}
</script>

<style>
#app {
  font-family: Microsoft YaHei;
}
</style>



// WEBPACK FOOTER //
// src/App.vue